'use client';

import { useCallback } from 'react';

import Link from 'next/link';

import { useNavigationBlocker } from './navigation-blocker';

interface CustomLinkProps extends React.ComponentProps<typeof Link> {
  children: React.ReactNode;
}

export function CustomLink({ children, ...props }: CustomLinkProps) {
  const { promptWaitForUnsavedChanges } = useNavigationBlocker();

  const onNavigate = useCallback(
    (e: { preventDefault: () => void }) => {
      if (promptWaitForUnsavedChanges()) {
        e.preventDefault();
      }
    },
    [promptWaitForUnsavedChanges],
  );

  return (
    <Link onNavigate={onNavigate} {...props}>
      {children}
    </Link>
  );
}
